import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Buttons from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Dropdown, Grid, Input, Button, Card, Form, TextArea } from 'semantic-ui-react';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import Items from './item';
import Tax from './tax';
import ReadCookie from '../../../functions/readcookies';
import OtherCharge from './othercharge';
import Checkbox from '@material-ui/core/Checkbox';
import Info from './info';

const styles = {
  appBar: { position: 'relative' },
  flex: { flex: 1 },
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class FullScreenDialog extends React.Component {

  state = {
    items: [], load: false, message: '', state: this.props.state,
    gstn: '', total: 0, invoice_date: '', taxsystem: false, amount: 0,
    partcodeOption: [], invoice: '', remarks: '', addDialog: false
  };

  componentDidMount() {
    this.getMode();
  }

  getPartCode() {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Alllow To Add!!!');
      return;
    }
    let context = this;
    context.setState({ load: true, message: 'Getting Partno!!!' });
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    $.ajax({
      type: 'POST',
      data: { 'branch': branch_id, 'customer': userId },
      url: Server() + 'purchasedetail/getpartcode.php',
      success: function(data) {
        console.log(data);
        var x = [];
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            let y = data[i];
            x.push({key: y.partno+'->'+y.spare_name+'->'+y.partno, text: y.partno+'->'+y.spare_name+'->'+y.part_id+'->'+y.brand_name, value: y.part_id});
          }
          context.setState({ partcodeOption1: x, partcodeOption: data, load: false, addDialog: true });
        } catch (e) { alert('Error to get Spares') }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!!')
      }
    });
  }

  getMode() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
      branch_id = data[i].branch_id;
    }
    $.ajax({
      type: 'POST',
      data: { 'executiveid': cook.id, 'branchId': branch_id },
      url: Server() + 'modecontrol/getmode.php',
      success: function(paymentmode)
      {
        try {
          paymentmode = JSON.parse(paymentmode);
          context.setState({ paymentmode, loading: false })
        } catch (e) { alert('Error to get payment mode!!!') }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };


  alertData() {
    let context = this;
    let items = context.state.items;
    items = JSON.stringify(items);
    this.setState({ load: true, message: 'Adding Spares!!!' })
    $.ajax({
      type: 'POST', data: { items: items, viewId: context.props.viewId },
      url: Server() + 'purchasedetail/alterpurchasedetails.php',
      success: function(data) {
        if (data == 1) {
          context.props.getorders(context.props.viewId, 'Yes');
          context.setState({ items: [], load: false, addDialog: false })
        }
        else {
          context.setState({ load: false })
        }
      },
      error: function(err) { console.log(err); context.setState({ load: false }) }
    })
  }

  submit() {
    let context = this;
    if (this.props.fromtype == 'alter') {
      this.alertData();
      return;
    }
    let items = this.state.items;
    let date = this.getDate();
    for (var i = 0; i < items.length; i++) {
      if (items[i].partname != 'OtherCharge') {
        if (!items[i].partno) { alert("Enter all partid"); return; }
        if (!items[i].stock || items[i].stock <= 0) { alert("Enter all stock"); return; }
        if (!items[i].branch) { alert("Enter the Branch"); return; }
        if (!items[i].brand) { alert("Enter all Brand"); return; }
        if (!items[i].dnp) { alert("Enter all DNP"); return; }
      }
    }
    let purchaser = this.child2.getPurchaserValue();
    let Invoice = this.child2.getInvoiceValue();
    let InvoiceDate = this.child2.getInvoiceDateValue();
    let purchaserAddress = this.child2.getPurchaserAddressValue();
    let selectedType = this.child2.getSelectTypeValue();
    if (!purchaser) { alert('Please Select Purchaser'); return; }
    if (!Invoice) { alert('Please Enter Invoice Number'); return; }
    if (!InvoiceDate) { alert('Please Enter Invoice Date'); return; }
    items = JSON.stringify(items);
    if (!this.state.selectedMode) { alert('Please Select Mode!!!'); return; }

    let data1 = { 'items': items, 'date': date, 'remarks': context.state.remarks,
      'selectedType': selectedType, 'selectedMode': context.state.selectedMode,
      'selectedModeid': context.state.selectedModeid, 'purchaser': purchaser, 'Invoice': Invoice,
      'InvoiceDate': InvoiceDate, 'purchaserAddress': purchaserAddress  };
    context.setState({ load: true, message: 'Adding Purchase details!!!' });
    $.ajax({
      type: 'POST', data: data1,
      url: Server() + 'purchasedetail/insert.php',
      success: function(data) {
        console.log(data);
        if (data == 1) {
          context.setState({ items: [], load: false, addDialog: false })
          context.props.getPurchaseDetails();
        }
        else {
          context.setState({ load: false })
        }
      },
      error: function(err) { console.log(err); context.setState({ load: false }) }
    })
  }

  addItem = () => {
    let items = this.state.items;
    let id = 0;
    items.map((c) => { id = c.id; })
    try { id = Number(id); }
    catch (e) { } id = id + 1;
    items.push({id: id, stock: 0 });
    this.setState({ items });
  }

  removeItem = (id) => () => {
    let items = [];
    this.state.items.map((x) => {
      if (x.id != id) { items.push(x); }
    });
    let d = 0;
    items.map((x) => { x.id = d++; })
    this.setState({ items });
  }

  updateItem = (id, type, value) => {
    let items = this.state.items;
    let total = this.state.total;
    for (var i = 0; i < items.length; i++) {
      if (items[i].id == id) {
        items[i][type] = value;
        items[i].branch = this.props.branch;
        items[i].total = items[i].stock * items[i].dnp;
        if (type == 'dnp') {
          items[i].changeindnp = 1;
        }
      }
    }
    this.setState({ items: items });
  }

  getDate() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if(dd < 10){ dd = '0' + dd; }
    if(mm < 10){ mm = '0' + mm; }
    today = yyyy+'-'+mm+'-'+dd;
    return today;
  }

  saveItems(items) { 
    items.map((c) => {
      let value = 0;
      let brandname = c.brandname;
      items.map((v) => {
        if (c.id != v.id && c.partno == v.partno && c.brandname == v.brandname) {
          value = v.id;
        }
      })
      if (value != 0) {
        c.backgroundColor = '#FDC6A5';
      }
    })
    this.setState({ items }); 
  }

  itemsUpdates(data) { this.setState({ items: data }) }

  paymentdropdown = event => {
    let value = event.target.value; let dropdown =  event.target.value;
    let modeid = value.split('->')[0]; let mode = value.split('->')[1];
    this.setState({ selectedMode: mode, selectedModeid: modeid, })
  }

  upDateState(state) {
    this.setState({ state })
  }

  onchangeTextHandle = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  render() {
    const { classes } = this.props;
    let total = 0; let tax = 0;
    let price = 0; let count = 0;
    let items = this.state.items.map((x) => {
      total = total + x.total;
      tax = tax + x.tax;
      count++;
      return (
        <Items id={x.id} count={count} remove={this.removeItem} partcodeOption={this.state.partcodeOption}
          updateItem={this.updateItem} load={this.state.load} message={this.state.message}
          addButton={this.addItem.bind(this)}
          items={this.state.items} saveItems={this.saveItems.bind(this)}
          invoice={this.state.invoice} invoiceDate={this.state.invoice_date}
           allItems={x} partcodeOption1={this.state.partcodeOption1}
          branch={this.props.branch} branchState={this.props.state} purchaseState={this.state.state}
          />
      );
    })

    let title = "Add Purchase";
    if (this.props.fromtype == 'alter') {
      title = "Add Item On Purchase ID :"+this.props.viewId;
    }

    return (
      <div>
        { this.props.fromtype == 'alter' ?
          (<Buttons color="primary" disabled onClick={this.getPartCode.bind(this)}>Add Item</Buttons>):
          (<Button onClick={this.getPartCode.bind(this)}>Add Purchase</Button>)
        }
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullScreen open={this.state.addDialog} onClose={ () => { this.setState({ items: [], addDialog: false }) }}
          TransitionComponent={Transition}>
          <AppBar className={classes.appBar}>
            <Toolbar>
              <IconButton color="inherit" onClick={ () => { this.setState({ items: [], addDialog: false }) }} aria-label="Close"><CloseIcon /></IconButton>
              <Typography variant="h6" color="inherit" className={classes.flex}>{title}</Typography>
            </Toolbar>
          </AppBar>
          <div  style={{padding: '1%'}}>
          <Loading load={this.state.loading} message={'Getting Spares'} />
          
          <Grid>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              { this.props.fromtype != 'alter' ?
                (<Info upDateState={this.upDateState.bind(this)} ref={instance => { this.child2 = instance; }} />):''
              }
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={16}>
              { this.state.items.length > 0 ?
                (
                  <div>
                    { this.props.state == this.state.state ?
                      (
                        <div>
                          <table width="100%" id='table'>
                            <tr>
                              <td  id='tableheader' style={{width: '5%'}}><center><b>Sino</b></center></td>
                              <td  id='tableheader' style={{width: '12%'}}><center><b>Partno</b></center></td>
                              <td  id='tableheader' style={{width: '14%'}}><center><b>PartId</b></center></td>
                              <td  id='tableheader' style={{width: '9%'}}><center><b>Brand</b></center></td>
                              <td  id='tableheader' style={{width: '9%'}}><center><b>Stock</b></center></td>
                              <td  id='tableheader' style={{width: '9%'}}><center><b>DNP</b></center></td>
                              <td  id='tableheader' style={{width: '7%'}}><center><b>Price</b></center></td>
                              <td  id='tableheader' style={{width: '8%'}}><center><b>SGST/CGST</b></center></td>
                              <td  id='tableheader' style={{width: '7%'}}><center><b>Total</b></center></td>
                              <td  id='tableheader' style={{width: '5%'}}><center></center></td>
                            </tr>
                            {items}
                          </table>
                        </div>
                      ) :
                      (
                        <div>
                          <table width="100%" id='table'>
                            <tr>
                              <td  id='tableheader' style={{width: '5%'}}><center><b>Sino</b></center></td>
                              <td  id='tableheader' style={{width: '12%'}}><center><b>Partno</b></center></td>
                              <td  id='tableheader' style={{width: '14%'}}><center><b>PartId</b></center></td>
                              <td  id='tableheader' style={{width: '9%'}}><center><b>Brand</b></center></td>
                              <td  id='tableheader' style={{width: '9%'}}><center><b>Stock</b></center></td>
                              <td  id='tableheader' style={{width: '9%'}}><center><b>DNP</b></center></td>
                              <td  id='tableheader' style={{width: '7%'}}><center><b>Price</b></center></td>
                              <td  id='tableheader' style={{width: '8%'}}><center><b>IGST</b></center></td>
                              <td  id='tableheader' style={{width: '7%'}}><center><b>Total</b></center></td>
                              <td  id='tableheader' style={{width: '5%'}}><center></center></td>
                            </tr>
                            {items}
                          </table>
                        </div>
                      )
                    }
                  </div>
                ):
                (<div></div>)
              }
              <br/>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  { this.props.fromtype != 'alter' ?
                    (
                      <div>
                        <OtherCharge selectedPurchaser={this.state.selectedPurchaser} items={this.state.items} itemsUpdates={this.itemsUpdates.bind(this)} /><br/>
                        <Form>
                          <TextArea fluid placeholder='Remarks' onChange={ this.handleChange('remarks')} value={this.state.remarks} />
                        </Form>
                      </div>
                    ):''
                  }
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                { this.state.items.length >= 1 ?
                  (
                    <div>
                      { this.props.fromtype != 'alter' ?
                        (
                          <div>
                            <Tax branchState={this.props.state} taxsystem={this.state.taxsystem}
                                 purchaseState={this.state.state} data={this.state.items}
                                 price={total} from={'b'} />
                            <br/>Payment Mode<br/>
                            <datalist id="suggestions2">
                                <option id='box2'>{'0->Credit'}</option>
                                {this.state.paymentmode.map((x) => {
                                  return ( <option id='box2'>{x.id+'->'+x.mode}</option> )
                                })}
                            </datalist>
                            <input style={{height: 35, width: '100%'}} onChange={this.paymentdropdown} autoComplete="on"
                            list="suggestions2" value={this.state.selectedMode}/> <br/>
                          </div>
                        ):''
                      }
                    </div>):''
                }
                </Grid.Column>
              </Grid>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              <Button fluid onClick={this.addItem}>Add</Button>
            </Grid.Column>
            <Grid.Column mobile={16} tablet={16} computer={8}>
              { this.state.items.length >= 1 ? ( <Button fluid onClick={this.submit.bind(this)}>Save</Button> ):'' }
            </Grid.Column>
          </Grid>
          </div>
        </Dialog>
      </div>
    );
  }
}

FullScreenDialog.propTypes = { classes: PropTypes.object.isRequired };

export default withStyles(styles)(FullScreenDialog);
